module.exports = __webpack_public_path__ + "static/media/circle.d11fdea1.png";